import { compose as t } from "../../tailwind-buddy-interface.js";
import { labelStyles as o } from "../../mixins/typography.js";
const s = t({
  slots: {
    root: (
      /** @tw */
      "max-w-full"
    ),
    icon: (
      /** @tw */
      "shrink-0"
    ),
    container: (
      /** @tw */
      ""
    )
  },
  variants: {
    /**
     * Sets the label font weight. `regular` should not be used in combination with `size=<"xxs"|"xs">` by design,
     * so it will fall back to `bold`.
     */
    fontWeight: {
      regular: "",
      bold: {
        root: (
          /** @tw */
          "font-weight-bold"
        )
      },
      extraBold: {
        root: (
          /** @tw */
          "font-weight-bolder"
        )
      }
    },
    /** Sets the label size. */
    size: {
      inherit: {
        root: ""
      },
      xxl: {
        root: o.xxl
      },
      xl: {
        root: o.xl
      },
      lg: {
        root: o.lg
      },
      md: {
        root: o.md
      },
      sm: {
        root: o.sm
      },
      xs: {
        root: o.xs
      },
      xxs: {
        root: o.xxs
      }
    }
  },
  responsiveVariants: ["size"],
  defaultVariants: {
    fontWeight: "regular",
    size: "md"
  },
  compoundVariants: [
    // _isContentWrapperNeeded="false"
    {
      conditions: {
        _isContentWrapperNeeded: !1
      },
      class: {
        root: (
          /** @tw */
          "inline-block"
        )
      }
    },
    // _isContentWrapperNeeded="true"
    {
      conditions: {
        _isContentWrapperNeeded: !0
      },
      class: {
        root: (
          /** @tw */
          "inline-flex items-center gap-x-025"
        )
      }
    },
    // noWrap="true"
    {
      conditions: {
        noWrap: !0
      },
      class: {
        container: (
          /** @tw */
          "truncate"
        )
      }
    },
    // `fontWeight="regular"` should not be used in combination with `size=<"xxs"|"xs">` by design,
    // so we fall back this to `bold`
    {
      conditions: {
        fontWeight: "regular",
        size: ["xxs", "xs"]
      },
      class: {
        root: (
          /** @tw */
          "font-weight-bold"
        )
      }
    }
  ]
})();
export {
  s as labelVariants
};
